<!--提单管理  -->
<template>
  <div class="bill_of_lading">
    <div class="search_button" style="margin-right: 20px">
      <span>已成交筛选：</span>
      <el-input
        placeholder="请输入内容"
        @input="input_search"
        v-model="search_name"
        class="input-with-select"
        style="margin-right: 20px; width: 300px"
        clearable
      >
        <el-select
          v-model="search_value"
          slot="prepend"
          placeholder="请选择"
          style="width: 120px"
          @change="option_input"
        >
          <el-option label="不限" value>不限</el-option>
          <el-option
            v-for="(item, value) in options"
            :key="item.label"
            :label="item.name"
            :value="value"
          ></el-option>
        </el-select>
      </el-input>
      <el-select
        v-model="sale_data"
        v-if="$cookies.get('auth_grade') >= 90"
        placeholder="请选择销售人员"
        style="width: 300px; margin-right: 12px"
        filterable
      >
        <el-option label="不限" value>不限</el-option>
        <el-option
          v-for="item in sale_options"
          :key="item.staff_id"
          :label="item.realname"
          :value="item.staff_id"
        ></el-option>
      </el-select>
      <el-cascader
        style="width: 300px; margin-right: 12px"
        v-model="place_value"
        :options="place_options"
        placeholder="搜索代理商公司所在地"
        :props="agent_props"
        clearable
        active-item-change=""
        v-if="$cookies.get('auth_grade') == 100"
      ></el-cascader>
      <el-button @click="button_search" icon="el-icon-search" type="primary"
        >搜索</el-button
      >
      <el-button
        @click="button_database"
        icon="el-icon-search"
        type="primary"
        v-if="$cookies.get('auth_grade') == 100"
        >数据分析</el-button
      >
    </div>
    <div class="tab_name">
      <div v-for="item in options" :key="item.name">
        <el-tag
          v-if="item.value != ''"
          style="margin: 10px 0; margin-right: 10px"
          @close="close_tab(item)"
          closable
          type
          >{{ item.name }}：{{ item.value }}</el-tag
        >
      </div>
    </div>

    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      v-loading="v_loading"
    >
      <!-- 待审核 -->
      <el-tab-pane label="待审核" name="first">
        <el-table :data="tableData" style="width: 100%; min-height: 80vh">
          <el-table-column label="状态" min-width="100">
            <template slot-scope="scope">
              <div v-if="$cookies.get('auth_grade') == 80">
                <el-tag
                  v-if="scope.row.agent_is_deal === 2"
                  type="success"
                  size="small"
                  >通过</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === ''"
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 1"
                  type="warning"
                  size="small"
                  >等待审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 3"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
              <div v-else>
                <el-tag
                  v-if="scope.row.is_money_back === 1"
                  type="success"
                  size="small"
                  >通过</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === ''"
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === 0"
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === 2"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="opened_account"
            label="开通账户"
          ></el-table-column>
          <el-table-column
            prop="client_name"
            label="客户姓名"
          ></el-table-column>
          <el-table-column
            prop="client_phone"
            label="客户手机"
          ></el-table-column>
          <!-- <el-table-column prop="client_wx" label="客户微信" min-width="100"></el-table-column> -->
          <el-table-column
            prop="client_source"
            label="客户来源"
          ></el-table-column>
          <el-table-column prop="company_name" label="公司名称">
            <!-- <template slot-scope="scope">
              <div :title="scope.row.company_name">
                {{
                scope.row.company_name.length > 5
                ? scope.row.company_name.substring(0, 5) + "..."
                : scope.row.company_name
                }}
              </div>
            </template>-->
          </el-table-column>
          <el-table-column label="公司地址">
            <template slot-scope="scope">
              {{ scope.row.place_name.city_name
              }}{{ scope.row.place_name.district_name }}
            </template>
          </el-table-column>
          <el-table-column
            :prop="
              $cookies.get('agent_company_name') == null
                ? 'industry'
                : 'industry_name'
            "
            label="公司行业"
          ></el-table-column>
          <el-table-column
            prop="deal_product"
            label="产品套餐"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="money_back"
            label="合同金额"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="agent_money_back"
            label="结算金额"
            width="100"
            v-if="$cookies.get('auth_grade') > 80"
          ></el-table-column>
          <el-table-column
            prop="sale_people_name"
            label="销售人"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column label="提单凭证" min-width="80px" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" trigger="click">
                <div class="scopeDiv">
                  <div>
                    <p>合同照片</p>
                    <el-image
                      v-if="scope.row.contract_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.contract_img == []
                          ? ''
                          : scope.row.contract_img[0]
                      "
                      :preview-src-list="scope.row.contract_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>合同打款照片</p>
                    <el-image
                      v-if="scope.row.money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.money_back_img == []
                          ? ''
                          : scope.row.money_back_img[0]
                      "
                      :preview-src-list="scope.row.money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') > 80">
                    <p>代理商结算照片</p>
                    <el-image
                      v-if="scope.row.agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.agent_money_back_img == []
                          ? ''
                          : scope.row.agent_money_back_img[0]
                      "
                      :preview-src-list="scope.row.agent_money_back_img"
                    ></el-image>
                  </div>
                  <div v-if="$cookies.get('auth_grade') > 90">
                    <p>省代结算照片</p>
                    <el-image
                      v-if="scope.row.province_agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.province_agent_money_back_img == []
                          ? ''
                          : scope.row.province_agent_money_back_img[0]
                      "
                      :preview-src-list="
                        scope.row.province_agent_money_back_img
                      "
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>营业执照照片</p>
                    <el-image
                      v-if="scope.row.business_license_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.business_license_img[0] == []
                          ? ''
                          : scope.row.business_license_img[0]
                      "
                      :preview-src-list="scope.row.business_license_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                </div>
                <el-button slot="reference" type="text">查看详情</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==100"
          ></el-table-column>
          <el-table-column
            prop="agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==80"
          ></el-table-column>
          <el-table-column
            prop="province_agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==90"
          ></el-table-column>-->

          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="examine(scope.row), '审核'"
                size="small"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- //已成交 -->
      <el-tab-pane
        label="已成交"
        name="second"
        style="width: 100%; min-height: 80vh"
      >
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="opened_account"
            label="开通账户"
          ></el-table-column>

          <el-table-column
            prop="client_name"
            label="客户姓名"
          ></el-table-column>
          <el-table-column
            prop="client_phone"
            label="客户手机"
          ></el-table-column>
          <!-- <el-table-column prop="client_wx" label="客户微信"></el-table-column> -->
          <el-table-column
            prop="client_source"
            label="客户来源"
          ></el-table-column>
          <el-table-column prop="company_name" label="公司名称">
            <!-- <template slot-scope="scope">
              <div :title="scope.row.company_name">
                {{
                scope.row.company_name.length > 5
                ? scope.row.company_name.substring(0, 5) + "..."
                : scope.row.company_name
                }}
              </div>
            </template>-->
          </el-table-column>
          <el-table-column label="公司地址">
            <template slot-scope="scope">
              {{ scope.row.place_name.city_name
              }}{{ scope.row.place_name.district_name }}
            </template>
          </el-table-column>
          <el-table-column
            :prop="
              $cookies.get('agent_company_name') == null
                ? 'industry'
                : 'industry_name'
            "
            label="公司行业"
          ></el-table-column>

          <el-table-column
            prop="deal_product"
            label="产品套餐"
          ></el-table-column>
          <el-table-column prop="money_back" label="合同金额"></el-table-column>
          <el-table-column
            prop="agent_money_back"
            label="结算金额"
            v-if="$cookies.get('auth_grade') > 80"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column
            prop="sale_people_name"
            label="销售人"
          ></el-table-column>
          <el-table-column
            prop
            label="所属代理商"
            v-if="$cookies.get('auth_grade') > 80"
          >
            <template slot-scope="scope">
              <span style="color: #f00; font-weight: bold">{{
                scope.row.city_agent_person_name || "无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="提单凭证" min-width="80px" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" trigger="click">
                <div class="scopeDiv">
                  <div>
                    <p>合同照片</p>
                    <el-image
                      v-if="scope.row.contract_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.contract_img == []
                          ? ''
                          : scope.row.contract_img[0]
                      "
                      :preview-src-list="scope.row.contract_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>合同打款照片</p>
                    <el-image
                      v-if="scope.row.money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.money_back_img == []
                          ? ''
                          : scope.row.money_back_img[0]
                      "
                      :preview-src-list="scope.row.money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') > 80">
                    <p>代理商结算照片</p>
                    <el-image
                      v-if="scope.row.agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.agent_money_back_img == []
                          ? ''
                          : scope.row.agent_money_back_img[0]
                      "
                      :preview-src-list="scope.row.agent_money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') > 90">
                    <p>省代结算照片</p>
                    <el-image
                      v-if="scope.row.province_agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.province_agent_money_back_img == []
                          ? ''
                          : scope.row.province_agent_money_back_img[0]
                      "
                      :preview-src-list="
                        scope.row.province_agent_money_back_img
                      "
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>营业执照照片</p>
                    <el-image
                      v-if="scope.row.business_license_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.business_license_img[0] == []
                          ? ''
                          : scope.row.business_license_img[0]
                      "
                      :preview-src-list="scope.row.business_license_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                </div>
                <el-button slot="reference" type="text">查看详情</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==100"
          ></el-table-column>
          <el-table-column
            prop="agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==80"
          ></el-table-column>
          <el-table-column
            prop="province_agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-if="$cookies.get('auth_grade')==90"
          ></el-table-column>-->
          <el-table-column
            label="操作"
            fixed="right"
            v-if="$cookies.get('auth_grade') == 100"
            :width="$cookies.get('auth_grade') == 100 ? '200' : '100'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  $cookies.get('auth_grade') == 100 &&
                  !scope.row.is_open_account
                "
                size="mini"
                type="primary"
                @click="create_hao(scope.row)"
                >创建帐号</el-button
              >
              <el-button
                v-if="$cookies.get('auth_grade') == 100"
                type="warning"
                @click="edit_info(scope.row)"
                size="small"
                >修改信息</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- //提交按钮提示框 -->
    <el-dialog
      :title="title"
      :visible.sync="is_submit"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="from" label-width="80px" :rules="rules">
        <el-form-item label="开通账户" prop="name">
          <el-input v-model="from.name" placeholder="请输入开通账户"></el-input>
        </el-form-item>
        <el-form-item label="合同金额" prop="money">
          <el-input
            v-model="from.money"
            placeholder="请输入合同金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品套餐" prop="meal">
          <el-input v-model="from.meal" placeholder="请输入套餐"></el-input>
        </el-form-item>
        <el-form-item label="合同照片" required>
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove_img"
            :file-list="imgArr"
            :on-success="imgSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="结算照片" required>
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove_payment"
            :file-list="paymentArr"
            :on-success="imgSuccess_payment"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="paymentVisible" :modal="false">
            <img width="100%" :src="paymentImageUrl" alt />
          </el-dialog>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              from = {};
              imgArr = [];
              imgData = [];
              paymentData = [];
              paymentArr = [];
              is_submit = false;
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="submitYes">确 定</el-button>
      </span>
    </el-dialog>
    <!-- //提交按钮提示框 -->
    <el-dialog
      :title="tit"
      :visible.sync="is_reject"
      width="30%"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        :rows="4"
        :placeholder="'请输入' + tit + '理由'"
        maxlength="250"
        :show-word-limit="true"
        v-model="textarea"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shenHe(2)">不通过</el-button>
        <el-button type="primary" @click="shenHe(1)">通过</el-button>
      </span>
    </el-dialog>
    <!-- /修改信息 -->
    <el-dialog
      title="修改信息"
      :visible.sync="is_info"
      width="30%"
      :before-close="close_info"
    >
      <el-form :model="form_info" label-width="80px">
        <el-form-item label="开通账户">
          <el-input v-model="form_info.opened_account"></el-input>
        </el-form-item>
        <el-form-item label="产品套餐">
          <el-input v-model="form_info.deal_product"></el-input>
        </el-form-item>
        <el-form-item label="结算数额">
          <el-input v-model="form_info.agent_money_back"></el-input>
        </el-form-item>
        <el-form-item label="合同图片">
          <!-- <el-input v-model="form_info.contract_img"></el-input> -->
          <span style="color: #f00; font-size: 12px">最多上传三张</span>
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove_img"
            :file-list="imgArr"
            :on-success="imgSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="合同打款照片">
          <!-- <el-input v-model="form_info.money_back_img"></el-input> -->
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :on-success="imgSuccess_payment"
          >
            <img v-if="paymentArr" :src="paymentArr" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="代理商结算图片">
          <!-- <el-input v-model="form_info.agent_money_back_img"></el-input> -->
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="success_agent_p"
          >
            <img
              v-if="success_agent_pArr"
              :src="success_agent_pArr"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="省代结算图片">
          <!-- <el-input v-model="form_info.agent_money_back_img"></el-input> -->
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="success_P_p"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="success_P_pArr" :src="success_P_pArr" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="营业执照图片">
          <!-- <el-input v-model="form_info.business_license_img"></el-input> -->
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="success_zhizhao"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户所在地区"
          ><el-cascader
            class="input"
            v-model="company_place"
            :options="place_list"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="用户所在行业">
          <!-- 获取的options值不是那种{value:'',label:''}格式，就需要自己定义利用props -->
          <el-cascader
            class="input"
            v-model="industry"
            :options="industry_data"
            :props="{ value: 'industry_id', label: 'name' }"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_quxiao">取 消</el-button>
        <el-button type="primary" @click="edit_Yes">确 定</el-button>
      </span>
    </el-dialog>
    <div class="page">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total"
        :page-size="15"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import axios from "axios";
import { require, url_Api } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      place_list: [],
      company_place: [],
      industry: [],
      industry_data: [],
      v_loading: false,
      url_Api: "",
      activeName: "first",
      //表单数据
      tableData: [],
      title: "提交",
      is_submit: false,

      //提交按钮上传合同照片开始
      from: {
        name: "",
        money: "",
        meal: "",
      },
      dialogImageUrl: "",
      paymentImageUrl: "",
      paymentVisible: false,
      dialogVisible: false,
      disabled: false,
      imgArr: [],
      imgData: [], //存储合同上传的文件id
      paymentArr: [],
      paymentData: [], //存储回款上传的文件id
      rules: {
        name: [
          { required: true, message: "请输入开通账户", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            min: 11,
            max: 11,
            message: "请输入11位手机号",
            trigger: "change",
          },
          {
            pattern: /^\d+$/,
            message: "请输入数字",
            trigger: "change",
          },
        ],
        money: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "请输入数字",
            trigger: "change",
          },
        ],
      },
      //提交按钮上传合同照片结束
      //驳回按钮事件开始
      is_reject: false,
      textarea: "",
      sale_people: [],
      sale_people_id: "",
      total: 1, //分页总数
      tag_name: "0",
      client_id: "", //客户id
      page: 0,
      tit: "审核",
      keHuid: "", //存储客户id
      options: [
        {
          name: "客户姓名",
          label: "client_name__icontains",
          value: "",
        },
        {
          name: "客户手机号",
          label: "client_phone__icontains",
          value: "",
        },
        {
          name: "公司名称",
          label: "company_name__icontains",
          value: "",
        },
      ],
      search_name: "",
      search_value: "",
      search_name_id: "",
      sale_options: [],
      sale_data: "",
      //修改信息数据
      is_info: false,
      form_info: {
        opened_account: "",
        deal_product: "",
        agent_money_back: "",
      },
      dialogImageUrl: "",
      paymentArr: "",
      success_agent_pArr: "",
      success_P_pArr: "",
      imageUrl: "",
      imgArr: [],
      imgData: [],
      deal_id: "",
      agent_props: {
        label: "name",
        value: "id",
        children: "children",
      },
      place_options: [],
      place_value: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    button_database() {
      this.$router.push({
        path: "/database",
      });
    },
    //修改信息
    edit_info(data) {
      console.log(data);
      this.company_place = [];
      this.deal_id = data.deal_id;
      this.form_info.opened_account = data.opened_account;
      this.form_info.deal_product = data.deal_product;
      if (data.agent_money_back) {
        this.form_info.agent_money_back = data.agent_money_back;
      } else {
        this.form_info.agent_money_back = data.agent_money_back;
      }
      this.imgArr = [];
      data.contract_img.map((item, index) => {
        this.imgArr.push({
          name: item,
          url: item,
          uid: data.contract_img_id.split(",")[index],
        });
        console.log("aaaa", this.imgArr);
      });
      this.imgData = data.contract_img_id.split(",");
      this.paymentArr = data.money_back_img[0];
      this.form_info.money_back_img = data.money_back_img_id;
      this.form_info.agent_money_back_img = data.agent_money_back_img_id;
      this.form_info.province_agent_money_back_img =
        data.province_agent_money_back_img_id;
      this.form_info.business_license_img = data.business_license_img_id;
      for (const key in data.place_name) {
        console.log(key);
        if (
          key == "city_code" ||
          key == "district_code" ||
          key == "province_code"
        ) {
          this.company_place.push(data.place_name[key]);
        }
      }
      if (this.company_place.length == 2) {
        this.company_place.unshift(this.company_place[0]);
      }
      this.industry = data.industry_id;
      this.success_agent_pArr = data.agent_money_back_img[0];
      this.success_P_pArr = data.province_agent_money_back_img[0] || "";
      this.imageUrl = data.business_license_img[0] || "";
      this.form_info = JSON.stringify(this.form_info); //：将值转换为 JSON 字符串。
      this.form_info = JSON.parse(this.form_info); //：将一个 JSON 字符串转换为对象。
      this.is_info = true;
    },
    //关闭弹窗修改信息
    close_info() {
      this.is_info = false;
    },
    //修改信息取消
    edit_quxiao() {
      this.is_info = false;
      this.form_info = {
        opened_account: "",
        deal_product: "",
        agent_money_back: "",
      };
    },
    //修改信息确定
    edit_Yes() {
      if (this.imgData.length > 0) {
        this.form_info.contract_img = this.imgData.join(",");
      }
      if (this.form_info.money_back) {
        this.form_info.money_back = Number(this.form_info.money_back);
      }
      require("post", "/lufish_sale/v1/update_deal_info/", {
        deal_id: this.deal_id,
        update_data: this.form_info,
        update_client: {
          industry: this.industry[this.industry.length - 1],
          company_place: this.company_place[this.company_place.length - 1],
        },
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          console.log(res);
          this.$message.success("修改成功");
          this.init(this.page, this.tag_name);
          this.is_info = false;
          this.form_info = {
            opened_account: "",
            deal_product: "",
            agent_money_back: "",
          };
          this.industry = [];
          this.company_place = [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //上传图片之前
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      //   if (!isJPG) {
      //     this.$message.error("上传头像图片只能是 JPG 格式!");
      //   }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt10M;
    },

    imgSuccess_payment(response) {
      //销售图片上传成功
      if (response.code == 0) {
        this.form_info.money_back_img = response.data.file_data.file_id;
        this.paymentArr = response.data.file_data.file_url;
      }
      console.log(this.paymentData);
    },
    success_agent_p(response) {
      console.log(response);
      //代理商图片上传成功
      if (response.code == 0) {
        this.form_info.agent_money_back_img = response.data.file_data.file_id;
        this.success_agent_pArr = response.data.file_data.file_url;
      }
      console.log(this.success_agent_pArr);
    },
    success_P_p(response) {
      //合同图片上传成功
      console.log(response);
      if (response.code == 0) {
        this.form_info.province_agent_money_back_img =
          response.data.file_data.file_id;
        this.success_P_pArr = response.data.file_data.file_url;
      }
      console.log(this.paymentData);
    },
    handleRemove_payment(file) {
      //销售合同证明删除
      console.log(this.paymentData);
      console.log(this.paymentArr);
      if (file.response) {
        this.paymentData = this.paymentData.filter((item, index) => {
          return item != file.response.data.file_data.file_id;
        });
      } else {
        this.paymentData = this.paymentData.filter((item, index) => {
          return item != file.uid;
        });
      }

      console.log(this.paymentData);
    },
    success_zhizhao(file) {
      // 图片参数
      console.log(file);
      this.form_info.business_license_img = file.data.file_data.file_id;
      // 展示图片变量
      this.imageUrl = file.data.file_data.file_url;
    },
    create_hao(data) {
      console.log(data.is_open_account)
      data.hr24_open_account = 1;
      let a = JSON.stringify(data);
      this.$cookies.set("across_nav_index", "2");
      // 竖向导航默认id
      this.$cookies.set("vertical_nav_index", "2-1");
      this.$router.push({
        name: "add_user",
        params: {
          id: a,
        },
      });
    },
    //标签点击
    handleClick(val) {
      console.log(val);
      this.tag_name = val.index;
      if (val.label == "已成交") {
        this.init(0, 1);
      } else {
        this.init(0, 0);
      }
    },

    //分页
    pageChange(page) {
      console.log(page);
      this.page = page - 1;
      this.init(Number(page - 1), Number(this.tag_name));
    },
    //提交按钮
    submit(row) {
      console.log(row);
      this.from = {};
      this.title = "提交";
      this.client_id = row.client_id;
      this.is_submit = true;
    },
    //提交按钮涉及的事件开始
    imgSuccess(response) {
      console.log(response);
      //合同图片上传成功
      if (response.code == 0) {
        this.imgData.push(response.data.file_data.file_id);
      }
      console.log(this.imgData);
    },
    handleRemove_img(file) {
      console.log(file);
      let uid = "";
      if (typeof file.uid == "string") {
        uid = file.uid;
      } else {
        uid = file.response.data.file_data.file_id;
      }
      this.imgData = this.imgData.filter((item, index) => {
        return item != uid;
      });
      console.log(this.imgData);
    },
    imgSuccess_payment(response) {
      //合同图片上传成功
      if (response.code == 0) {
        this.paymentData.push(response.data.file_data.file_id);
      }
      console.log(this.paymentData);
    },
    handleRemove_payment(file) {
      this.paymentData = this.paymentData.filter((item, index) => {
        return item != file.response.data.file_data.file_id;
      });
      console.log(this.paymentData);
    },
    handlePictureCardPreview(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    //提交确定按钮
    submitYes() {
      console.log(this.imgData, this.paymentData);
      console.log(typeof this.from.name);
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
      });

      if (JSON.stringify(this.from) == "{}") {
        this.$message({
          type: "error",
          message: "请填写必填项",
        });
        return false;
      }

      if (this.imgData.length == 0) {
        this.$message({
          type: "error",
          message: "请上传合同照片",
        });
        return false;
      }
      if (this.paymentData.length == 0) {
        this.$message({
          type: "error",
          message: "请上传结算照片",
        });
        return false;
      }
      let obj = {
        create_data: {
          client_id: this.client_id,
          deal_product: this.from.meal,
          money_back: this.from.money,
          contract_img: this.imgData.join(","),
          money_back_img: this.paymentData.join(","),
          opened_account: this.from.name,
        },
      };
      require("post", "/lufish_sale/v1/create_sale_deal/", obj).then((res) => {
        
        console.log(res);
        if (res.code == 0) {
          console.log(res);
          this.$message.success("提交成功");
          this.init(this.page, this.tag_name);
          this.is_submit = false;
          this.from = {};
          this.imgArr = [];
          this.imgData = [];
          this.paymentData = [];
          this.paymentArr = [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //提交按钮涉及的事件结束
    //审核按钮
    shenHe(data) {
      let url = "";
      let obj = {};
      if (this.$cookies.get("agent_company_name") === null) {
        console.log("acvsghcvashgvcavsvh");
        url = "/lufish_sale/v1/check_deal/";
        obj = {
          deal_id: this.keHuid,
          is_money_back: data,
          check_remarks: this.textarea,
          aaa: { aa: "scsac" },
          sale: {
            client_id: data.client_id,
            agent_money_back: data.agent_money_back,
          },
        };
        console.log(obj);
      } else if (this.$cookies.get("auth_grade") == 90) {
        url = "/lufish_sale/v1/province_agent_check_deal/";
        obj = {
          deal_id: this.keHuid,
          province_agent_is_deal: data + 1,
          province_agent_check_remarks: this.textarea,
        };
      } else {
        url = "/lufish_sale/v1/agent_check_deal/";
        obj = {
          deal_id: this.keHuid,
          agent_is_deal: data + 1,
          agent_check_remarks: this.textarea,
        };
      }
      require("post", url, obj).then((res) => {
        console.log(res);
        if (res.code == 0) {
          console.log(res);
          this.$message.success("提交成功");
          this.init(this.page, this.tag_name);
          this.is_reject = false;
          this.textarea = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    examine(row) {
      this.keHuid = row.deal_id;
      console.log(row);
      this.is_reject = true;
    },

    //驳回按钮
    reject() {
      this.is_reject = true;
    },

    //弹窗关闭
    handleClose() {
      this.from = {};
      this.imgArr = [];
      this.imgData = [];
      this.paymentData = [];
      this.paymentArr = [];
      this.is_submit = false;
      this.is_reject = false;
    },
    //初始化
    init(page, status) {
      this.v_loading = true;
      let Obj = {
        page,
        deal_status: status,
      };
      // let search_data = {}
      if (status == 1) {
        let search_data = {};
        let index = 0;
        // city_id
        this.options.forEach((item) => {
          if (item.value != "") {
            search_data[item.label] = item.value;
            console.log(search_data);
          } else {
            index++;
          }
        });

        if (this.place_value.length == 2) {
          search_data.company_place =
            this.place_value[this.place_value.length - 1];
        }

        Obj.sale_people_id = this.sale_data;

        Obj.search_data = search_data;
      }
      console.log(this.$cookies.get("auth_grade"));
      if (this.$cookies.get("auth_grade") == 20) {
        require("post", "/lufish_sale/v1/deal_list/", Obj).then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.tableData = [];
            res.data.deal_data.forEach((element) => {
              if (!element.place_name) {
                console.log(1545345);
                element.place_name = { city_name: "", district_name: "" };
              }
            });
            this.tableData = res.data.deal_data;
            console.log(this.tableData);
            this.total = res.data.deal_count;
          }
          this.v_loading = false;
        });
      } else {
        let url = "";
        if (this.$cookies.get("agent_company_name") === null) {
          url = "/lufish_sale/v1/admin_deal_list/";
        } else {
          url = "/lufish_sale/v1/agent_admin_deal_list/ ";
        }
        if (this.$cookies.get("auth_grade") == 90) {
          url = "/lufish_sale/v1/province_agent_admin_deal_list/";
        }
       
        require("post", url, Obj).then((res) => {
          console.log(res);
          if (res.code == 0) {
       
            this.tableData = [];
            res.data.deal_data.forEach((element) => {
              if (this.$cookies.get("auth_grade") == 90) {
                element.agent_money_back = element.province_agent_money_back;
                element.sale_people_name = element.city_agent_person_name;
              }

              if (!element.place_name) {
                console.log(1545345);
                element.place_name = { city_name: "", district_name: "" };
              }
            });
            this.tableData = res.data.deal_data;
            this.total = res.data.deal_count;
          }
          this.v_loading = false;
        });
      }
    },

    button_search() {
      // console.log('搜索', this.tag_name)
      if (this.tag_name == 1) {
        this.init(0, 1);
      } else {
        this.$message({
          message: "此功能仅限筛选已成交的合同",
          type: "warning",
        });
      }
    },
    input_search(e) {
      // console.log('输入的内容', e)
      if (this.search_value !== "") {
        this.options[this.search_name_id].value = e;
      }
    },
    option_input(e) {
      // console.log('筛选', e)
      this.search_name = "";
      if (e === "") {
        this.search_name_id = "";
        this.options.forEach((item) => {
          item.value = "";
        });
      } else {
        this.search_name_id = e;
      }
    },
    close_tab(e) {
      // 关闭Tab 标签
      // console.log('删除', e)
      e.value = "";
    },
    //获取代理商地区列表
    agent_place() {
      require("post", "/lufish_user/v1/all_agent_city/", {}).then((res) => {
        this.place_options = res.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.url_Api = url_Api;
    this.init(0, 0);
    this.agent_place();
    if (this.$cookies.get("auth_grade") == 100) {
      require("post", "/lufish_sale/v1/all_agent_list/", {}).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.sale_options = res.data;
        }
      });
    }
    if (this.$cookies.get("auth_grade") == 90) {
      require("post", "/lufish_sale/v1/all_agent_user/", {
        is_agent: 5,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.sale_options = res.data;
        }
      });
    }
    //is_add:0  为没有不限  或者为有不限
    require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
      console.log(res);
      if (res.code == 0) {
        this.place_list = res.data;
      }
    });
    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.bill_of_lading {
  position: relative;
  width: calc(100% - 209px);
  left: 181px;
  top: 68px;
  padding: 14px;
}
.page {
  padding: 12px 0;
  text-align: right;
}

.search_button {
  display: flex;
  align-items: center;
  background: white;
  padding: 10px;
}
.search_button {
  font-size: 14px;
}
.tab_name {
  border-top: 1px #ccc solid;
  display: flex;
  padding: 10px;
  flex-wrap: wrap;
  min-height: 60px;
  background: white;
}
.color {
  color: #3e84e9;
  cursor: pointer;
}
.scopeDiv {
  width: 100%;
  /* display: flex; */
}
.scopeDiv > div {
  float: left;
  padding: 0 6px;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;
  border-right: 2px solid rgb(233, 233, 233);
}
.scopeDiv > div:last-child {
  border-right: none;
}
.scopeDiv > div > p {
  padding: 6px;
  margin: 0;
  font-size: 12px;
  color: #3b3b3b;
}
.scopeDiv > div > .D_div {
  display: inline-block;
  width: 80px;
  line-height: 80px;
  text-align: center;
  background: #f5f7fa;
  color: #c0c4cc;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 120px;
  text-align: center;
  position: relative;
  /* padding-top: 100px; */
  top: 0px;
  border: #8c939d dashed 1px;
  border-radius: 5px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 30px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/to_examine.vue